export default __webpack_public_path__ + "static/media/popup-img.39250a56.avif";